// Fix responsive (2026-08-14): col-3 sin prefijo agrupaba siempre 4 campos
// por fila — cada celda (input numérico + typeahead de unidad, ver Lab.js)
// quedaba en ~75px reales en un celular de 375px, ilegible/inoperable. Con
// col-6 col-md-3 son 2 por fila en mobile (~180px c/u, usable) y las mismas
// 4 por fila que antes desde md (768px) hacia arriba.
function LabRow(props) {
  let missingDivs = [];

  if (props.array.length < 4) {
    let missing = 4 - props.array.length;

    for (let i = 0; i < missing; i++) {
      missingDivs.push(<div className="col-6 col-md-3 px-0"></div>);
    }
  }

  return (
    <div className="container">
      <div className="row">
        {props.array.map((element, index) => (
          <div key={index} className="col-6 col-md-3 px-0 py-2">{element}</div>
        ))}
      </div>
    </div>
  );
}

export default LabRow;
